import React, {Component} from 'react';
import {Link, Redirect} from "react-router-dom";
import './Navbar.css';

export default class Navbar extends Component {
    state = {
        redirectBool: false
    };
    copyApi = () => {
        const text = localStorage.getItem('uuid');
        navigator.clipboard.writeText(text).then(function () {
            alert('Copied your api to clipboard');
        }, function (err) {
            console.error('Async: Could not copy text: ', err);
        });
    };

    logout = () => {
        localStorage.setItem('uuid', undefined);
        localStorage.setItem('plotItem', undefined);
        this.setState({redirectBool: true});
    };

    redirectToHome = () => {
        if (this.state.redirectBool) {
            return (<Redirect to='/'/>);
        }
    };

    render() {
        return (<div>
            {this.redirectToHome()}
            <nav className="navbar navbar-expand-lg navbar-light bg-light">
                <button className="navbar-toggler" type="button" data-toggle="collapse"
                        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"> </span>
                </button>

                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ol>
                        <li className="nav-item">
                            <Link className='nav-link' to='/home'>Home <span><i
                                className="fas fa-home"> </i></span></Link>
                        </li>
                        <li className="nav-item">
                            <Link className='nav-link' to='/plot-menu'>Plot Menu <span><i
                                className="fas fa-chart-line"> </i></span></Link>
                        </li>

                        <li className="nav-item">
                            <Link className='nav-link' to='/switch'>Switches <i
                                className="fas fa-power-off"> </i></Link>
                        </li>
                        <li className="nav-item">
                            <Link className='nav-link' to='/map-list'>Map Menu <span><i
                                className="fas fa-map-marker-alt"> </i></span></Link>
                        </li>
                        <li className="nav-item">
                            <p className='nav-link' onClick={this.copyApi}>API <span><i
                                className="fas fa-tape"> </i></span></p>
                        </li>

                        <li className="nav-item">
                            {/*<i className="fas fa-github nav-item"> </i>*/}
                            <p className='nav-link' onClick={() => {
                                window.open('https://github.com/dazzHere/PY-PLOTS-MAPS');
                            }}>Github <span><i className="fab fa-github"> </i></span></p>
                        </li>
                        <li className="nav-item">
                            <p className='nav-link' onClick={this.logout}>{localStorage.getItem('myName')} <span><i
                                className="fas fa-sign-out-alt"></i></span></p>
                        </li>
                    </ol>
                </div>
            </nav>
        </div>);
    }
}